export enum RefundStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  REJECTED = 'REJECTED',
}

export const refundStatusNameMap: Record<RefundStatus, string> = {
  [RefundStatus.PENDING]: 'Bekliyor',
  [RefundStatus.SUCCESS]: 'Başarılı',
  [RefundStatus.REJECTED]: 'Reddedildi',
};
